import { createEffect, createEvent, forward, sample } from "effector";
import { audioLoadEnded, audioLoadStarted, audioStarted, audioStopped, audio, } from "frontend/src/domain/audio";
import { setPlayerTrackQueue } from "frontend/src/domain/player-track-queue";
export var pause = createEvent();
export var play = createEvent();
export var resume = createEvent();
export var resetAudio = createEvent();
var playFx = createEffect(function (url) {
    audio.src = url;
    return audio.play();
});
var resumeFx = createEffect(function () { return audio.play(); });
export var pauseFx = createEffect(function () { return audio.pause(); });
var resetAudioFx = createEffect(function () {
    audio.pause();
    audio.src = "";
});
forward({
    from: play,
    to: [playFx, audioLoadStarted],
});
forward({
    from: resume,
    to: resumeFx,
});
forward({
    from: pause,
    to: pauseFx,
});
forward({
    from: [playFx.done, resumeFx.done],
    to: [audioStarted, audioLoadEnded],
});
forward({
    from: pauseFx,
    to: [audioStopped, audioLoadEnded],
});
sample({
    clock: setPlayerTrackQueue,
    target: resetAudio,
});
sample({
    clock: resetAudio,
    target: [resetAudioFx, audioStopped],
});
